
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.516.336h8.453v2.719h-.766a7.11 7.11 0 00-.344-1.063 2.048 2.048 0 00-.351-.594 1.106 1.106 0 00-.406-.289c-.141-.057-.355-.086-.641-.086h-.992v8c0 .308.015.553.047.735.036.182.088.328.156.437.073.104.17.188.289.25.12.058.307.115.562.172V11h-3.57v-.383c.156-.036.294-.075.414-.117a.998.998 0 00.29-.148.692.692 0 00.187-.235 1.19 1.19 0 00.117-.383c.031-.161.047-.398.047-.71v-8h-.985c-.244 0-.447.023-.609.07a.967.967 0 00-.437.297c-.136.145-.26.356-.375.632a7.35 7.35 0 00-.313 1.032H.516V.335z","fill":"currentColor"}})])
          )
        }
      }
    